import { getAtPath } from "@/v2/framework/dialog/composables/useDialogContext";

export function readEntitySlice(
  values: Record<string, unknown>,
  entityPath?: string,
): Record<string, unknown> | undefined {
  if (!entityPath) {
    return values;
  }

  const slice = getAtPath(values, entityPath);
  return slice && typeof slice === "object" && !Array.isArray(slice)
    ? (slice as Record<string, unknown>)
    : undefined;
}
